import { yup, parsePhoneNumber } from "./imports";

export const signupStepOneSchema = (selectedCountryCode: Ref<string>) => {
  return computed(() =>
    yup.object({
      name: yup.string().required("Please enter your name"),
      mobile: yup
        .string()
        .required("Please enter your mobile number")
        .test("is-valid-mobile", "Invalid phone number", function (value) {
          const fullNumber = `${selectedCountryCode.value}${value}`;
          return parsePhoneNumber(fullNumber)?.isValid() || false;
        }),
      email: yup
        .string()
        .email("Please enter a valid email address")
        .required("Please enter your email"),
    }),
  );
};

export const signupStepTwoSchema = () => {
  return computed(() =>
    yup.object({
      password: yup
        .string()
        .min(8, "Password must be at least 8 characters")
        .required("Please enter your password"),
      password_confirmation: yup
        .string()
        .oneOf([yup.ref("password")], "Passwords do not match")
        .required("Please enter your confirm password"),
    }),
  );
};
